export default {
  created: function () { },
  methods: {
    CreateAvaiableRawMaterialList(response) {
      var result = [];
      for (var i = 0; i < response.data.length; i++) {
        var item = response.data[i];
        result.push(this.CreateRawMaterialObject(item.fullName, item.id, item.availableWeight, item.serialNumber, item.rawMaterialTypeId));
      }
      return result;
    },
    CreateRawMaterialObject(name, id, availableWeight, serialNumber, rawMaterialTypeId) {
      return {
        fullName: name,
        id: id,
        availableWeight: availableWeight,
        serialNumber: serialNumber,
        rawMaterialTypeId: rawMaterialTypeId,
        maxWeightToUse: 0
      };
    },
    ValidateWeightForRawMaterial(selectedRawMaterial) {
      if (selectedRawMaterial.usedWeight) {
        var item = selectedRawMaterial;
        var availableWeight = item.selectedRawMaterial.maxWeightToUse
          ? item.rawMaterial.maxWeightToUse
          : item.rawMaterial.availableWeight;

        var usedWeight = parseFloat(item.usedWeight);
        return usedWeight <= availableWeight && usedWeight > 0
      } else {
        return true;
      }

    },
    CreateCouverture() {
      return {
        couverture: {},
        weight: 0,
      };
    },
    CreateMeltDownProduct() {
      return {
        meltDownProduct: null,
        weight: 0,
      };
    }
  },
};
